var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.537 5.394a.857.857 0 1 1 1.212 1.212l-4.537 4.537h11.645c.44 0 .802.33.852.757l.005.1a.857.857 0 0 1-.857.857H7.212l4.537 4.537a.857.857 0 0 1 .071 1.131l-.071.081a.857.857 0 0 1-1.212 0l-6-6-.063-.07a1.292 1.292 0 0 1-.063-.09.786.786 0 0 1-.095-.218.808.808 0 0 1-.03-.228l.003.076a.874.874 0 0 1-.003-.06V12a.825.825 0 0 1 .042-.268.821.821 0 0 1 .126-.242.86.86 0 0 1 .083-.096l-.069.077a.86.86 0 0 1 .069-.077l6-6Z",
    fill: "currentColor"
  })));
};
export default SvgBack;